import type { UseFernieDictationReturn } from "~/hooks/useFernieDictation";

import { Box, Icon, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

import { CancelButton } from "~/components/Buttons";
import FernieFaceAnimated from "~/components/fernie/FernieFaceAnimated";
import FernieVoiceText from "~/components/fernie/FernieVoiceText";
import { BodyTextSmall } from "~/components/Typographies";

interface FernieDictationBarProps {
	dictation: UseFernieDictationReturn;
}

const FernieDictationBar = ({ dictation }: FernieDictationBarProps) => {
	const { t } = useTranslation("common");
	const { cancel, dismissNotice, notice, phase } = dictation;

	return (
		<Box aria-live="polite" role="status">
			{phase !== "idle" && (
				<Box sx={{ alignItems: "center", display: "flex", gap: 1, mb: 1, px: 0.5 }}>
					<FernieFaceAnimated decorative size={24} state={phase === "recording" ? "listening" : "thinking"} />
					<FernieVoiceText sx={{ color: "text.secondary", flex: 1, fontSize: "0.78rem" }}>
						{phase === "recording" ? t("fernieChat.dictation.recording") : t("fernieChat.dictation.transcribing")}
					</FernieVoiceText>
					<CancelButton aria-label={t("fernieChat.dictation.cancel")} onClick={cancel} size="small" />
				</Box>
			)}
			{notice && (
				<Box sx={{ alignItems: "flex-start", display: "flex", gap: 1, mb: 1, px: 0.5 }}>
					<Icon sx={{ color: "text.secondary", fontSize: 16, mt: 0.25 }}>info</Icon>
					<BodyTextSmall sx={{ color: "text.secondary", flex: 1, fontSize: "0.75rem" }}>
						{t(`fernieChat.dictation.notice.${notice}`)}
					</BodyTextSmall>
					<IconButton aria-label={t("fernieChat.dictation.dismiss")} onClick={dismissNotice} size="small">
						<Icon sx={{ fontSize: 14 }}>close</Icon>
					</IconButton>
				</Box>
			)}
		</Box>
	);
};

export default FernieDictationBar;
